module.exports = __webpack_public_path__ + "img/22.ebf895a1.png";